const staging = {
  apiUrl: "https://staging.api.rolerelay.com/graphql",
  authConfig: {
    Auth: {
      Cognito: {
        userPoolId: "ap-southeast-2_ni1uCMCNV",
        userPoolClientId: "6tacaega9lh4hppt8h4prb9oqu",
        loginWith: {
          email: true,
        },
      },
    },
  },
  jobAdder: {
    integrationUrl:
      "https://staging.api.rolerelay.com/api/integrations/jobadder/connecturl",
    callbackUrl:
      "https://staging.api.rolerelay.com/api/integrations/jobadder/callback",
  },
  vincere: {
    integrationUrl:
      "https://staging.api.rolerelay.com/api/integrations/vincere/connecturl",
    callbackUrl:
      "https://staging.api.rolerelay.com/api/integrations/vincere/callback",
    syncJobs:
      "https://staging.api.rolerelay.com/api/integrations/vincere/syncJobs",
  },
  bullhorn: {
    integrationUrl:
      "https://staging.api.rolerelay.com/api/integrations/bullhorn/connecturl",
    callbackUrl:
      "https://staging.api.rolerelay.com/api/integrations/bullhorn/callback",
  },
  postHog: {
    apiKey: "phc_OcoQEXMubaYU0mxWQk76bqQnxXzTBoFBvgVllRdfD0P",
    disableSessionRecordings: true,
    featureFlags: {
      showImported: "staging_show-imported",
      showAccordionSettings: "staging_show-accordion-settings",
      showMatchesPage: "staging_show-matches-page",
      showAdvancedSearch: "staging_show-advanced-search",
      showFeedbackSurvey: "staging_show-feedback-survey",
      isDownMaintenance: "staging_is-down-maintenance",
      showDemoProjects: "staging_show-demo-projects",
      showDashboard: "staging_show-dashboard",
      showExperiments: "staging_show-experiments",
    },
  },
  reCaptchaKey: "6LeXDfYpAAAAAPUP3sBOMfvgZXb84IdJFhY2i7-S",
};

type Config = typeof staging;

const production: Config = {
  apiUrl: "https://dev.api.rolerelay.com/graphql",
  authConfig: {
    Auth: {
      Cognito: {
        userPoolId: "ap-southeast-2_VK0lAbaOr",
        userPoolClientId: "44qv7uibgt18qq8c9q7s7sar",
        loginWith: {
          email: true,
        },
      },
    },
  },
  jobAdder: {
    integrationUrl:
      "https://dev.api.rolerelay.com/api/integrations/jobadder/connecturl",
    callbackUrl:
      "https://dev.api.rolerelay.com/api/integrations/jobadder/callback",
  },
  vincere: {
    integrationUrl:
      "https://dev.api.rolerelay.com/api/integrations/vincere/connecturl",
    callbackUrl:
      "https://dev.api.rolerelay.com/api/integrations/vincere/callback",
    syncJobs: "https://dev.api.rolerelay.com/api/integrations/vincere/syncJobs",
  },
  bullhorn: {
    integrationUrl:
      "https://dev.api.rolerelay.com/api/integrations/bullhorn/connecturl",
    callbackUrl:
      "https://dev.api.rolerelay.com/api/integrations/bullhorn/callback",
  },
  postHog: {
    apiKey: "phc_EHYoOdXRmcmXCB20hOnLKXpQw1HG77OIuaF4drTFUe9",
    disableSessionRecordings: false,
    featureFlags: {
      showImported: "show-imported",
      showAccordionSettings: "show-accordion-settings",
      showMatchesPage: "show-matches-page",
      showAdvancedSearch: "show-advanced-search",
      showFeedbackSurvey: "show-feedback-survey",
      isDownMaintenance: "is-down-maintenance",
      showDemoProjects: "show-demo-projects",
      showDashboard: "show-dashboard",
      showExperiments: "show-experiments",
    },
  },
  reCaptchaKey: "6LeXDfYpAAAAAPUP3sBOMfvgZXb84IdJFhY2i7-S",
};

// Local development with local backend (requires running rr-next-backend locally)
const local: Config = {
  apiUrl: "https://localhost:7260/graphql",
  authConfig: staging.authConfig,
  jobAdder: {
    integrationUrl:
      "https://localhost:7260/api/integrations/jobadder/connecturl",
    callbackUrl:
      "https://localhost:7260/api/integrations/jobadder/callback",
  },
  vincere: {
    integrationUrl:
      "https://localhost:7260/api/integrations/vincere/connecturl",
    callbackUrl:
      "https://localhost:7260/api/integrations/vincere/callback",
    syncJobs: "https://localhost:7260/api/integrations/vincere/syncJobs",
  },
  bullhorn: {
    integrationUrl:
      "https://localhost:7260/api/integrations/bullhorn/connecturl",
    callbackUrl:
      "https://localhost:7260/api/integrations/bullhorn/callback",
  },
  postHog: staging.postHog,
  reCaptchaKey: staging.reCaptchaKey,
};

// Local development with staging backend (no local backend required)
const localStaging: Config = {
  apiUrl: "https://staging.api.rolerelay.com/graphql",
  authConfig: staging.authConfig,
  jobAdder: staging.jobAdder,
  vincere: staging.vincere,
  bullhorn: staging.bullhorn,
  postHog: staging.postHog,
  reCaptchaKey: staging.reCaptchaKey,
};

const config: Config =
  process.env.REACT_APP_ENV === "staging"
    ? staging
    : process.env.REACT_APP_ENV === "local"
      ? local
      : process.env.REACT_APP_ENV === "local-staging"
        ? localStaging
        : production;
export default config;
